import React from 'react';
import FormsBanner from '../../components/FormsPages/FormsBanner'
import FamilyTherapyForm from './familyTestForm';


const AdminFormPage = () => {
    return (
        <div className='therapyFrom-container'>
            <FormsBanner FormTitle="Admin Test" />
            <FamilyTherapyForm />
        </div>
    );
};

export default AdminFormPage;